import * as types from '../constants/actionTypes';

// Fetch Orders
export const fetchOrdersRequest = () => ({
  type: types.FETCH_ORDERS_REQUEST
});

export const fetchOrdersSuccess = (orders) => ({
  type: types.FETCH_ORDERS_SUCCESS,
  payload: orders
});

export const fetchOrdersFailure = (error) => ({
  type: types.FETCH_ORDERS_FAILURE,
  payload: error
});

// Create Order
export const createOrderRequest = (orderData) => ({
  type: types.CREATE_ORDER_REQUEST,
  payload: orderData
});

export const createOrderSuccess = (order) => ({
  type: types.CREATE_ORDER_SUCCESS,
  payload: order
});

export const createOrderFailure = (error) => ({
  type: types.CREATE_ORDER_FAILURE,
  payload: error
});

// Update Order
export const updateOrderRequest = (id, orderData) => ({
  type: types.UPDATE_ORDER_REQUEST,
  payload: { id, orderData }
});

export const updateOrderSuccess = (order) => ({
  type: types.UPDATE_ORDER_SUCCESS,
  payload: order
});

export const updateOrderFailure = (error) => ({
  type: types.UPDATE_ORDER_FAILURE,
  payload: error
});

// Delete Order